import { FC, Fragment, ReactNode, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import CookieBanner from "../CookieBanner";
import { dataTrack } from "~/hooks/useDataTracker";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  useEffect(() => {
    dataTrack("VISIT_LANDING_PAGE");
  }, []);

  return (
    <Fragment>
      <Header />
      {children}
      <Footer />
      <CookieBanner />
    </Fragment>
  );
};

export default Layout;
